import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    HeatingCurveService,
    IconService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'heating-curve-shift',
    templateUrl: './heating-curve-shift.component.html',
    styleUrls: ['./heating-curve-shift.component.scss']
})
export class HeatingCurveShiftComponent implements OnInit, AfterViewInit {
    constructor(
        public control: ControlService,
        public heatingCurve: HeatingCurveService,
        private icon: IconService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit() {
        this.heatingCurve.drawHeatingShift();
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
